import React, {useEffect, useMemo, useState} from "react";
import useFilter from "../hooks/useFilter";
import useThemeToggle from "../hooks/useThemeToggle";
import {useDispatch, useSelector} from "react-redux";
import {getProfile} from "../store/actions/profileActions";

const AppContext = React.createContext();

const AppProvider = ({children}) => {
    const dispatch = useDispatch();
    const {theme, toggleTheme} = useThemeToggle();
    const {profile} = useSelector((state) => state.profile);
    const {invoices} = useSelector((state) => state.invoices);
    const {filteredInvoices, filters, changeFilter} = useFilter(invoices);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [isInvoiceEdited, setIsInvoiceEdited] = useState(false);
    const [editedInvoice, setEditedInvoice] = useState(null);
    const isAdmin = useMemo(() => profile?.role === 'admin', [profile]);


    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (!profile) {
            dispatch(getProfile());
        }
    }, []);

    return (
        <AppContext.Provider
            value={{
                theme,
                toggleTheme,
                windowWidth,
                filteredInvoices,
                filters,
                changeFilter,
                isFormOpen,
                setIsFormOpen,
                isInvoiceEdited,
                setIsInvoiceEdited,
                editedInvoice,
                setEditedInvoice,
                isAdmin,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export {AppContext, AppProvider};
